import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/Order.requests'
import {
    CustomerTransportRequestParams,
} from 'app/Apps/OrderManagement/Orders/CustomerTransport/CreateAirlineLease/createCustomerTransportForm.types'
import simpleApi from 'app/services/simpleApi'

const useCreateCustomerTransportOrder = (onSuccess: ({
    orderNumber,
}: {orderNumber: string}) => void) => {
    const token = useJWTToken()
    const {
        onError,
    } = useHandleStatusRequest({
        id: 'CreateOrder',
    })

    return useMutation({
        mutationFn: (data: CustomerTransportRequestParams) => {
            return simpleApi({
                ...requests.createCustomerTransport({
                    data,
                }),
                token,
            })
        },
        onSuccess,
        onError,
    })
}

export default useCreateCustomerTransportOrder
